import ApiMethods from '../ApiMethods'
import ENDPOINTS from '../Endpoints'

class AuthApiManager {
    static authToken = (data) => {
        data = {
            ...data,
            grant_type: 'password',
            client_id: 'MdO6QONxC_fI0xvbRq7wLZxa6Q1cDYHh7xPkYcdLy_Q',
            client_secret: 'cliente_simple_oauth2023OKTV',
        }

        let dataUser = new URLSearchParams()
        dataUser.append('grant_type', 'password')
        dataUser.append('client_id', data.client_id)
        dataUser.append('client_secret', data.client_secret)
        dataUser.append('username', data.username)
        dataUser.append('password', data.password)

        return ApiMethods.post(ENDPOINTS.AUTH_LOGIN, dataUser, {
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: 'application/json',
        })
    }

    static hasPermission = (roleToEvaluate) => {
        var operatorData = localStorage.getItem('operador')
        if(operatorData){

            var { role } = JSON.parse(operatorData)
            //Suscriptor, Operador
            return role === roleToEvaluate;
        }
        return false;
    }
}

export default AuthApiManager
